import React , {Component} from 'react'
import { connect } from 'react-redux'
import { Progress, Row, Col, Button } from 'reactstrap'
import getBaseQuery from '../../helpers/assessment/getBaseQuery';
import { Link,Redirect } from 'react-router-dom'
import { link } from 'fs';


/*
  <AssessSkillBar
    nodeName={nodeScore.name}
    raw={nodeScore.raw}
    possible={nodeScore.possible}
    percent={Math.round(nodeScore.raw / nodeScore.possible * 100)}
    color={themeColors[props.subtest.displayName] ? themeColors[props.subtest.displayName] : fallbackThemeColor}
    key={`skillBar${nodeScore.name}`}
    isStudent={this.props.userAssessmentId ? true : false}
  />
*/
let test = null ;

 class AssessSkillBar extends Component {

  constructor(props) {
    super(props)

    this.state = {
      activeParentReport: '',
    }

    this.setActiveParent = this.setActiveParent.bind(this)
  }

  setActiveParent(id) {
    this.setState((prevState, props) => {
      if (prevState.activeParentReport == id) {
        return { activeParentReport: '' }
      } else {
        return { activeParentReport: id }
      }
    })
  }


  
  
  
  render (){


    let {nodeName,
      raw,
      possible,
      percent,
      color,
      testName,
      isStudent,
      usedAsFilter,
      margin,
      nodeId,
      isParent,
      setActiveParent,
      isActiveParent,
      query,
      navTo,
      nodeFilter,
      className,
      skillReportLink,
      percentCompare,
      props,
      byNodeScoringCompare,
      linkToReport,
      test,
      isCompare
    } = this.props
      

      let linkto = null
      if(props && props.query){
        linkto = `/assessment/testing/${props.routeParams.userAssessmentId}/${props.routeParams.subTestSetId}?item=overview&g=${props.query.g}&a=${props.query.a}`
      }
   
      let testNameLowerCase = testName ? testName.toLowerCase() : testName;
  let value = <span className='value numeric' >{raw} / {possible} correct</span>
  if (!isStudent) {
    value = <span className='value percent'>{`${percent}%`} correct</span>
  }
  function getNdQuery(query, nodeFilter, nodeId) {
    const baseQuery = getBaseQuery(query, 'nd')
    let endQuery = ''
    if (nodeFilter !== nodeId) {
      endQuery = `&nd=${nodeId}`
    }
    return `${baseQuery}${endQuery}`
  }
  const ndQuery = getNdQuery(query, nodeFilter, nodeId)

  const marg = margin ? `${margin}` : ``
  const filt = nodeFilter === nodeId && usedAsFilter ? 'filtered' : ''
  const par = isActiveParent ? 'expanded' : ''
  const cl = `skill ${color} ${marg} ${filt} ${par} ${className}`

  
 
    return (
    // <li className={margin ? `skill ${margin}` : `skill`}>
  
<div>





 
{ linkto ?  
<li className={cl}>
<Row noGutters>
<Col
xs={usedAsFilter && isParent ? '12' : '12'}
onClick={usedAsFilter ? () => navTo(ndQuery) : null}
className={usedAsFilter ? 'm2clickable' : ''}
>
<Row className='title-and-score' noGutters>
<Col xs='12' className='title-and-score-col'>
  <span className='title'>
    {`${nodeName}`}
  </span>
  <span className="score-percentage">
    {value}
  </span>
</Col>        
</Row>
<Row className='bars' noGutters>
<Col xs={usedAsFilter && isParent ? '11' : '12'} >
{/* -----------------------------------------------------(fir the skill card)----------->||||||||||||||||||||||||||||||||||||<-=------------------------------------------------------ */}
<Progress  color={color} value={percent} />

{isCompare && 
    <div className = "compare_prog" >
    <Progress  color={color} value={percentCompare} />
    </div>}
</Col>
{usedAsFilter && isParent
  ? <Col
  xs='1'
  onClick={(e) => {
    e.stopPropagation()
    setActiveParent(nodeId)
   
  }}
  className='m2clickable skill-expander'
  >
    {(isActiveParent)
      ? <div className='skill-expander-icon'>v</div> :
      <div className='skill-expander-icon'>></div>
    }
  </Col>
  : null
}
</Row>
</Col>
</Row>
</li>
    :  
    <li className={cl}>
<Row noGutters>
<Col
xs={usedAsFilter && isParent ? '12' : '12'}
onClick={usedAsFilter ? () => navTo(ndQuery) : null}
className={usedAsFilter ? 'm2clickable' : ''}
>
<Row className='title-and-score' noGutters>
<Col xs='12' className='title-and-score-col'>
  <span className='title'>
    {`${nodeName}`}
  </span>
  <span className="score-percentage">
    {value}
  </span>
</Col>        
</Row>
    <Row className='bars' noGutters>
<Col xs={usedAsFilter && isParent ? '11' : '12'} >

<Progress  color={color} value={percent} />
{isCompare  && 
    <div className = "compare_prog" >
      <Progress  color={color} value={percentCompare} />
    </div>}
</Col>
{usedAsFilter && isParent
  ? <Col
    xs='1'
    onClick={(e) => {
      e.stopPropagation()
      setActiveParent(nodeId)
    }}
    className='m2clickable skill-expander'
  >
    {(isActiveParent)
      ? <div className='skill-expander-icon'>v</div> :
      <div className='skill-expander-icon'>></div>
    }
  </Col>
  : null
}
</Row>
</Col>
</Row>
</li>
}
    
</div>
    )
  }
 
}
export default connect(
  (state) => ({
    isCompare : state.assessment.isCompare,
  })
)(AssessSkillBar)


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSkillBar.js